import { render, staticRenderFns } from "./TicketsChatHeader.vue?vue&type=template&id=5c1f2fce&"
import script from "./TicketsChatHeader.vue?vue&type=script&lang=js&"
export * from "./TicketsChatHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports